module.exports = __webpack_public_path__ + "images/7a3273393666e7ba5c2b833fd04b07dd-logo_white.png";